import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import UserPublicResponseResource from "common/resources/User/UserPublicResponseResource";
import Button, { EButtonVariant } from "components/elements/Button";
import Table from "components/elements/Table";
import { ECellType, IRowProps, TableColumn } from "components/elements/Table/MuiTable";
import I18n from "components/materials/I18n";
import { useCallback, useEffect, useState } from "react";
import UserService from "services/UserService";
import { container } from "tsyringe";
import classes from "./classes.module.scss";

const userService = container.resolve(UserService);

type IProps = {
	officeId: string;
	onSelectCgp: (cgpId: string) => void;
};

export default function UsersList({ officeId, onSelectCgp }: IProps) {
	const [rows, setRows] = useState<IRowProps[]>([]);

	const onSearch = useCallback((search?: string) => userService.getByOfficeId(officeId, search).then((users) => setRows(buildRows(users, onSelectCgp))), [officeId, onSelectCgp]);

	useEffect(() => {
		userService.getByOfficeId(officeId).then((users) => setRows(buildRows(users, onSelectCgp)));
	}, [officeId, onSelectCgp]);

	return <Table columnsHead={columnsHead} rows={rows} placeholderSearchbar={I18n.asset.common.search} onNext={null} onSearch={onSearch} />;
}

function buildRows(users: UserPublicResponseResource[], onSelectCgp: (cgpId: string) => void): IRowProps[] {
	return users.map((user) => {
		return {
			rowKey: user.id,
			name: user.lastName,
			firstName: user.firstName,
			cabinet: user.offices![0]?.raisonSociale,
			creationDate: user.createdAt ?? null,
			userLastLoginAt: user.lastLoginAt ?? null,
			nbOfSubscriptions: user.nbOfSubscriptions,
			select: (
				<Button variant={EButtonVariant.TEXT} onClick={() => onSelectCgp(user.id)}>
					{I18n.asset.common.select}
					<ArrowLongRightIcon className={classes["icon"]} />
				</Button>
			),
		};
	});
}

const columnsHead: readonly TableColumn[] = [
	{
		headContent: I18n.asset.pages.partners.table.columns.name,
		key: "name",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.first_name,
		key: "firstName",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.cabinet,
		key: "cabinet",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.creation_date,
		key: "creationDate",
		formatType: ECellType.DATE,
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.number_of_subscriptions,
		key: "nbOfSubscriptions",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.last_login_at,
		key: "userLastLoginAt",
		formatType: ECellType.DATE,
	},
	{
		headContent: "Status",
		key: "registered_status",
	},
	{
		headContent: "",
		key: "select",
	},
];
